import React from "react";
import { useNavigate } from "react-router-dom";
import { TiltSpotlightCard } from "../../../components/ui/TiltSpotlightCard";

const IdentitySpotlight = () => {
  const navigate = useNavigate();
  const goToAuth = () => navigate("/authentication-portal");

  return (
        <section className="w-full bg-white py-20 md:py-28 px-4">
            <div className="max-w-3xl mx-auto text-center mb-14">
        <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-foreground mb-4">
          Your learning has an identity.
        </h2>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
          A certificate can tell someone what you completed. Nesolearn goes further,
          connecting your courses, progress, and proof of achievement into one record
          that stays with you for life.
        </p>
      </div>

            <div
        className="flex flex-wrap items-center justify-center gap-10 md:gap-8 lg:gap-10"
        style={{ perspective: "1000px" }}
      >
           <TiltSpotlightCard
          title="Nesolearn ID"
          subtitle="One identity. A lifetime of learning."
          imageUrl="https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/3778b487-83c6-43e6-ae4d-2220274f9725_removalai_preview.png"
          actionText="Claim Your Nesolearn ID"
          href="/authentication-portal"
          onActionClick={goToAuth}
        />
                <TiltSpotlightCard
          title="Proof of Learning"
          subtitle="Don't just say you learned it. Prove it."
          imageUrl="https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/f769fcf2-29d1-40a9-8f6e-92fd05e9bf26_removalai_preview.png"
          actionText="Discover Proof of Learning"
          href="/authentication-portal"
          onActionClick={goToAuth}
        />
                <TiltSpotlightCard
          title="Opportunity"
          subtitle="What you know should open doors."
          imageUrl="https://images.unsplash.com/photo-1758270705290-62b6294dd044?q=80&w=1200"
          actionText="Explore Opportunities"
          href="/authentication-portal"
          onActionClick={goToAuth}
        />
      </div>
    </section>
  );
};

export default IdentitySpotlight;